// Meeting exit paths wait for the registered board before destroying media.
const flushers = new Map();
export const registerClassBoardFlush = (roomId, flush) => {
  const key = String(roomId || '');
  if (!flushers.has(key)) flushers.set(key, new Set());
  flushers.get(key).add(flush);
  return () => { flushers.get(key)?.delete(flush); if (!flushers.get(key)?.size) flushers.delete(key); };
};
export const flushClassBoards = async (roomId, options = {}) => {
  await Promise.all([...(flushers.get(String(roomId || '')) || [])].map((flush) => flush(options)));
};
const keyFor = (roomId, userId) => `class-board-draft-v1:${String(userId)}:${String(roomId)}`;
export const readClassBoardDraft = (roomId, userId) => {
  if (!userId) return null;
  try { return JSON.parse(localStorage.getItem(keyFor(roomId, userId)) || 'null'); } catch { return null; }
};
export const writeClassBoardDraft = (roomId, userId, draft) => {
  if (!userId) return false;
  try { localStorage.setItem(keyFor(roomId, userId), JSON.stringify({ ...draft, savedLocallyAt: new Date().toISOString() })); return true; } catch { return false; }
};
export const clearClassBoardDraft = (roomId, userId, sourceId, revision) => {
  const draft = readClassBoardDraft(roomId, userId);
  if (draft && draft.sourceId === sourceId && Number(draft.clientRevision) <= Number(revision)) {
    try { localStorage.removeItem(keyFor(roomId, userId)); } catch { /* Browser storage can be disabled. */ }
  }
};
export const listClassBoardDrafts = (userId) => {
  if (!userId) return [];
  try {
    const prefix = `class-board-draft-v1:${String(userId)}:`;
    return Object.keys(localStorage).filter((key) => key.startsWith(prefix)).map((key) => {
      try { return JSON.parse(localStorage.getItem(key)); } catch { return null; }
    }).filter((draft) => draft?.roomId && draft.pages?.length);
  } catch { return []; }
};
